import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 15 16",
  stroke: "white",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.95007 1.80192L3.7567 2.35353C1.9189 3.20303 1 3.62778 1 4.325C1 5.02222 1.9189 5.44697 3.7567 6.29647L4.95007 6.84809C6.10664 7.38269 6.68493 7.65 7.29997 7.65C7.91501 7.65 8.4933 7.38269 9.64987 6.84808L10.8432 6.29647C12.681 5.44697 13.5999 5.02222 13.5999 4.325C13.5999 3.62778 12.681 3.20303 10.8432 2.35353L9.64987 1.80192C8.4933 1.26731 7.91501 1 7.29997 1C6.68493 1 6.10664 1.26731 4.95007 1.80192Z",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.4515 7.36823C13.5505 7.50736 13.5999 7.65236 13.5999 7.81183C13.5999 8.49912 12.681 8.91782 10.8432 9.75522L9.64987 10.299C8.4933 10.826 7.91501 11.0895 7.29997 11.0895C6.68493 11.0895 6.10664 10.826 4.95007 10.299L3.7567 9.75523C1.9189 8.91782 1 8.49912 1 7.81183C1 7.65236 1.04947 7.50736 1.1484 7.36823",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.1636 10.9865C13.4545 11.2182 13.5999 11.4491 13.5999 11.7225C13.5999 12.4098 12.681 12.8285 10.8432 13.6659L9.64987 14.2097C8.4933 14.7367 7.91501 15.0002 7.29997 15.0002C6.68493 15.0002 6.10664 14.7367 4.95007 14.2097L3.7567 13.6659C1.9189 12.8285 1 12.4098 1 11.7225C1 11.4491 1.14544 11.2182 1.43633 10.9865",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }